import React from 'react';
import { Printer } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function PrintOrder() {
  return <div className="min-h-screen bg-white p-8 max-w-4xl mx-auto" data-id="element-1361">
      <div className="mb-8 print:hidden" data-id="element-1362">
        <Button onClick={() => window.print()} className="gap-2" data-id="element-1363">
          <Printer className="h-4 w-4" data-id="element-1364" />
          Print Order
        </Button>
      </div>

      <div className="border border-slate-200 p-8 space-y-8" data-id="element-1365">
        {/* Header */}
        <div className="flex justify-between items-start" data-id="element-1366">
          <div data-id="element-1367">
            <h1 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-1368">
              Desert Sage Seminars
            </h1>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-1369">
              <p data-id="element-1370">123 Education Lane</p>
              <p data-id="element-1371">Phoenix, AZ 85001</p>
              <p data-id="element-1372">CALL US: (555) 123-4567</p>
              <p data-id="element-1373">Fax: (555) 987-6543</p>
              <p data-id="element-1374">E-Mail: info@desertsageseminars.com</p>
            </div>
          </div>
          <div className="text-right text-sm space-y-1" data-id="element-1375">
            <p data-id="element-1376">
              <span className="font-semibold" data-id="element-1377">Date:</span> 2023-10-15
            </p>
            <p data-id="element-1378">
              <span className="font-semibold" data-id="element-1379">Order id:</span> ORD-2023-001
            </p>
            <p data-id="element-1380">
              <span className="font-semibold" data-id="element-1381">Order status:</span> Processed
            </p>
          </div>
        </div>

        <hr className="border-slate-200" data-id="element-1382" />

        {/* Customer Info */}
        <div className="grid grid-cols-2 gap-8" data-id="element-1383">
          <div data-id="element-1384">
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-1385">Customer Info</h3>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-1386">
              <p data-id="element-1387">
                <span className="font-semibold" data-id="element-1388">Company:</span> Acme Landscaping
              </p>
              <p data-id="element-1389">
                <span className="font-semibold" data-id="element-1390">First Name:</span> John
              </p>
              <p data-id="element-1391">
                <span className="font-semibold" data-id="element-1392">Last Name:</span> Doe
              </p>
              <p data-id="element-1393">
                <span className="font-semibold" data-id="element-1394">Phone:</span> 555-0123
              </p>
              <p data-id="element-1395">
                <span className="font-semibold" data-id="element-1396">Fax:</span> -
              </p>
              <p data-id="element-1397">
                <span className="font-semibold" data-id="element-1398">E-Mail:</span> john@example.com
              </p>
              <p data-id="element-1399">
                <span className="font-semibold" data-id="element-1400">URL:</span> -
              </p>
            </div>
          </div>
          <div data-id="element-1401">
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-1402">Billing Address</h3>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-1403">
              <p data-id="element-1404">
                <span className="font-semibold" data-id="element-1405">Address:</span> 123 Desert Way
              </p>
              <p data-id="element-1406">
                <span className="font-semibold" data-id="element-1407">City:</span> Phoenix
              </p>
              <p data-id="element-1408">
                <span className="font-semibold" data-id="element-1409">State:</span> AZ
              </p>
              <p data-id="element-1410">
                <span className="font-semibold" data-id="element-1411">Zip:</span> 85001
              </p>
            </div>
          </div>
        </div>

        {/* Products Table */}
        <table className="w-full text-sm text-left border-collapse" data-id="element-1412">
          <thead data-id="element-1413">
            <tr className="bg-slate-50 border-y border-slate-200" data-id="element-1414">
              <th className="py-2 px-4 font-semibold text-slate-900" data-id="element-1415">SKU</th>
              <th className="py-2 px-4 font-semibold text-slate-900" data-id="element-1416">
                Product
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-right" data-id="element-1417">
                Item price
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-center" data-id="element-1418">
                Quantity
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-right" data-id="element-1419">
                Total
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200" data-id="element-1420">
            <tr data-id="element-1421">
              <td className="py-3 px-4" data-id="element-1422">C-101</td>
              <td className="py-3 px-4" data-id="element-1423">Desert Ecology Basics</td>
              <td className="py-3 px-4 text-right" data-id="element-1424">$49.00</td>
              <td className="py-3 px-4 text-center" data-id="element-1425">1</td>
              <td className="py-3 px-4 text-right" data-id="element-1426">$49.00</td>
            </tr>
          </tbody>
        </table>

        {/* Totals */}
        <div className="flex justify-end" data-id="element-1427">
          <div className="w-64 space-y-2 text-sm" data-id="element-1428">
            <div className="flex justify-between" data-id="element-1429">
              <span className="text-slate-600" data-id="element-1430">Subtotal:</span>
              <span className="font-medium" data-id="element-1431">$49.00</span>
            </div>
            <div className="flex justify-between" data-id="element-1432">
              <span className="text-slate-600" data-id="element-1433">Coupon saving (SUMMER23):</span>
              <span className="font-medium text-green-600" data-id="element-1434">-$10.00</span>
            </div>
            <div className="flex justify-between border-t border-slate-200 pt-2" data-id="element-1435">
              <span className="text-slate-600" data-id="element-1436">Discounted subtotal:</span>
              <span className="font-medium" data-id="element-1437">$39.00</span>
            </div>
            <div className="flex justify-between border-t border-slate-900 pt-2 text-base font-bold" data-id="element-1438">
              <span data-id="element-1439">Total:</span>
              <span data-id="element-1440">$39.00</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-slate-200 text-center" data-id="element-1441">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-50 rounded border border-slate-200" data-id="element-1442">
            <span className="font-bold text-slate-700" data-id="element-1443">Authorize.Net</span>
            <span className="text-xs text-slate-500" data-id="element-1444">
              Secure Payment Processing
            </span>
          </div>
        </div>
      </div>
    </div>;
}